<template>
    <div>
        <b-modal
            id="select_store_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="headline" v-html="headline"></p>
                </div>
                <div class="modal-base-body">
                    <p id="message" v-html="message"></p>
                </div>

                <div class="province mb-4" :class="{'disable-dropdown': subCampaignList.length <= 0}">
                    <b-dropdown class="ddl-default"
                            variant="ddl-default"
                            menu-class="ddl-menu"
                            :class="{'placeholder-text': texSelectStore == 'Select Store'}"
                            :text="texSelectStore">
                        <div v-for="(v,k) in subCampaignList" :key="k">
                            <b-dropdown-item @click="selectBranch(v)" v-if="v.quantity - v.itemCountSold > 0">
                                <div class="name" >
                                    {{v.name}}
                                </div>
                            </b-dropdown-item>
                        </div>
                    </b-dropdown>
                </div>
                <div class="modal-base-footer btn-redeem-wrapper">
                    <button class="btn btn-cancel" @click="clickCloseSelectStore()">{{lblConfirmRedeem.cancel2}}</button>
                    <button class="btn ml-2 btn-confirm"
                        :class="{'disable': !selectCampaignId}"
                        @click="clickConfirmSelectStore()">{{lblConfirmRedeem.confirm2}}</button>
                </div>
            </div>
        </b-modal>
        <modal view="select-store"
            :busModal="busModal"
            @modalAlertHidden="clickOkModalAlert($event)"></modal>
    </div>
</template>
<script>
//import Vue from "vue";
import Locale from "@/helper/locale/locale.js";
import Account from "@/helper/AccountHelper.js";
import { TrackingService } from "@/helper/TrackingHelper";
import Modal from '@/components/modal/Modal.vue';

export default {
    name: 'SelectStoreModal',
     components: {

        Modal,
    },
    props: {
        lbl: Object,
        campaign: Object,
        busModal: Object
    },
    data: function () {
        return {
            headline: '',
            message: '',
            texSelectStore: '',
            selectCampaignId: "",

            lblConfirmRedeem: {},
            lblDate: {},
            monthList:[],
            subCampaignList:[],

            localeCode: Locale,
            // busModal: new Vue(),
            tracking: new TrackingService(this),
            userId: null,
            trackCamp: null
        };
    },
    mounted: function () {
        console.log("confirmredeem");
        this.lblDate = this.lbl.date;
        this.lblConfirmRedeem = this.lbl.confirm_redeem;
        this.busModal.$on('showSelectStoreModal', this.initialConfirmModal);
        this.busModal.$on('hideSelectStoreModal', this.closeConfirmModal);

        this.userId = Account.getLineUserId();
        this.trackCamp = this.userId + "|" + this.campaign.id + "|" + this.campaign.name;
    },
    methods: {
        //Event
        clickConfirmSelectStore: function () {
            // console.log(this.info3 = "Store brance");
            if (this.selectCampaignId) {
                var redeemitem = {
                    id: this.selectCampaignId,
                    name: this.texSelectStore
                }
                this.$emit('clickConfirmSelectBranch', redeemitem);
                this.tracking.event('Privilege', 'click_Redemtion_success', this.trackCamp);
                this.closeConfirmModal();
            }
        },
        selectBranch: function (item) {
            this.texSelectStore = item.name;
            this.selectCampaignId = item.campaignId;
        },
        clickCloseSelectStore: function () {
            this.closeConfirmModal();
            this.tracking.event('Privilege', 'click_Redemtion_cancel', this.trackCamp);
        },
        //Function
        initialConfirmModal: function (list) {

            this.headline = this.lblConfirmRedeem.freegift_confirm;
            this.message = this.lblConfirmRedeem.select_freegift_store;

            this.subCampaignList = list;

            this.texSelectStore = this.lblConfirmRedeem.select_placeholder;

            this.$bvModal.show('select_store_modal');

        },
        closeConfirmModal: function () {
            this.$bvModal.hide('select_store_modal');
        },
        showAlertModal: function(title, message, btnOk, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                tag: tag,
            };
            this.busModal.$emit('showAlertModal', configModal);
        },
        clickOkModalAlert: function (e) {
           console.log(e);

        },

    }
}
</script>
<style lang="scss">
    $url-dropdown-icon: url('../../../../assets/img/01-register/dropdown@3x.png');
    @import "@/style/base/common.scss";
    @import "@/style/base/inputCustom/Dropdown.scss";

    #select_store_modal{


        .ddl-default {
            width: 100%;

            &.placeholder-text {

                .btn-ddl-default {
                    color: #9c9c9c;
                }
            }
        }

        .modal-dialog{
            margin-left: 2rem;
            margin-right: 2rem;
            .modal-content{

                border-radius: 0px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    #headline {
        text-align: center;
        font-weight: bold;
    }
    #headline2 {
        text-align: center;
    }

    #message {
        text-align: center;
    }

    #select_store_modal{

        .btn-redeem-wrapper {
            text-align: center;
            display: flex;
            flex-wrap: nowrap;

            .btn-cancel {
                width: 50%;
                background-color: white;
                color: black;
                border-color: black;
                border-radius: 0;
                text-transform: uppercase;
                font-weight: bold;
            }

            .btn-confirm {
                width: 50%;
                background-color: black;
                color: white;
                border-color: black;
                text-transform: uppercase;
                font-weight: bold;
                border-radius: 0;

                &.disable {
                    background-color: #9c9c9c;
                    border-color: #9c9c9c;
                    pointer-events: none;
                }
            }
        }

        .disable-dropdown {
            pointer-events: none;
        }
    }
</style>
